import React from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

import NoAccess from '../Common/NoAccess';
import Schedule from './Schedule';
import ScheduleForm from './ScheduleForm';

export const ScheduleIndex = () => {
    const local = useSelector((state) => state.org.remember);
    const permissions = useSelector((state) => state[local ? 'localUser' : 'user'].permissions).split(',');
    const exhibitDiver = parseInt(useSelector((state) => state[local ? 'localUser' : 'user'].exhibitDiver));
    const modules = useSelector((state) => state.org.modules);

    return (
        <>
            <Routes>
                <Route element={<ProtectedRoute isAllowed={(permissions.indexOf('Schedule') >= 0 || exhibitDiver) && modules.indexOf('Schedule') >= 0} />}>
                    <Route index element={<Schedule />} />
                    <Route path=":teamId/:date" element={<ScheduleForm />} />
                </Route>
                <Route path="*" element={<div className="error-404">There's nothing here: 404!</div>} />
            </Routes>
        </>
    );
};

export default ScheduleIndex;

const ProtectedRoute = ({ isAllowed, children }) => {
    if (!isAllowed) {
      return <NoAccess />;
    } else 
      return <>
        {children ? children : <Outlet />}
      </>;
};